import {
  employeeHasTeamInDepartments,
  type EmployeeTeamDepartments,
} from '@app/reducers/orm/employee/employee.selectors';

import { type MinijobPayoutEmployeeResponse } from './services/minijob-payout.model';

/**
 * The payout endpoint answers for every Minijob employee the manager may edit, account-wide
 * (SHB-14863); it takes no department filter. The payroll flow scopes a run to departments, so the
 * step narrows the response here to employees whose team sits in one of them. `null` keeps the
 * modal's own department-agnostic behaviour.
 */
export function scopedMinijobEmployees(
  employees: MinijobPayoutEmployeeResponse[],
  teamDepartments: EmployeeTeamDepartments,
  departmentIds: string[] | null,
): MinijobPayoutEmployeeResponse[] {
  if (departmentIds === null) {
    return employees;
  }

  return employees.filter((employee) => employeeHasTeamInDepartments(employee.id, teamDepartments, departmentIds));
}
